import { TDeviceType } from '@cian/ui-kit';

export function getSiteType(deviceType: TDeviceType) {
  return deviceType === 'phone' ? 'mobile' : deviceType;
}
